import { ReactComponent as IconCheckmarkSimilarityGreen } from '../../public/images/svg/icon_checkmark_similarity_green.svg';
import { ReactComponent as IconCheckmarkSimilarityRed } from '../../public/images/svg/icon_checkmark_similarity_red.svg';
import { ReactComponent as IconCheckmarkSimilarityYellow } from '../../public/images/svg/icon_checkmark_similarity_yellow.svg';

export const COPYSCAPE = {
  Green: {
    icon: <IconCheckmarkSimilarityGreen />,
    bgColor: 'bg-green-100',
    contentTitle: "The generated haven't been copied from other sites"
  },
  Amber: {
    icon: <IconCheckmarkSimilarityYellow />,
    bgColor: 'bg-yellow-100',
    contentTitle: 'Generated text contain pieces copied from other sites'
  },
  Red: {
    icon: <IconCheckmarkSimilarityRed />,
    bgColor: 'bg-red-200',
    contentTitle: 'Generated text is considered to have been copied content from other sites'
  }
};
